export const FormFieldTypes = {
  Text: 'Text',
  Number: 'Number',
  Checkbox: 'Checkbox',
  Select: 'Select',
  Date: 'Date',
  Datetime: 'DateTime'
};
